import * as React from "react"
const Gamesvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      enableBackground: "new 0 0 512 512",
    }}
    viewBox="0 0 512 512"
    {...props}
  >
    <path d="M369.5 180c-45.6 0-63.6 31.4-73.1 54.2-7.3-14.9-22.7-25.1-40.4-25.1s-33 10.3-40.4 25.1c-9.5-22.8-27.5-54.2-73.1-54.2C37.5 180 .2 392.2.2 435.1c0 56.8 31.9 76.9 59.2 76.9 48 0 99.6-82.1 124.5-123h144.4c24.9 41 76.7 123 124.5 123 27.3 0 59.2-20.1 59.2-76.9C511.9 417 483.8 180 369.5 180zM166.1 299h-15v15c0 8.3-6.7 15-15 15s-15-6.7-15-15v-15h-15c-8.3 0-15-6.7-15-15s6.7-15 15-15h15v-15c0-8.3 6.7-15 15-15s15 6.7 15 15v15h15c8.3 0 15 6.7 15 15s-6.8 15-15 15zm120 30h-60c-8.3 0-15-6.7-15-15s6.7-15 15-15h60c8.3 0 15 6.7 15 15s-6.8 15-15 15zm89.9-90c8.3 0 15 6.7 15 15s-6.7 15-15 15-15-6.7-15-15 6.8-15 15-15zm-30 60c-8.3 0-15-6.7-15-15s6.7-15 15-15 15 6.7 15 15-6.7 15-15 15zm30 30c-8.3 0-15-6.7-15-15s6.7-15 15-15 15 6.7 15 15-6.7 15-15 15zm30-30c-8.3 0-15-6.7-15-15s6.7-15 15-15 15 6.7 15 15-6.7 15-15 15z" />
    <path d="M272.3 180.7a78.8 78.8 0 0 0-16.2-1.7c-4.7 0-9.4.4-13.9 1.3-1.3-19.3-5.6-39.4-15.9-49.8-26.5-26.5-92.3-8-130.5-8.5C31.6 121-.8 84.8.1 39.1c.2-9.2.7-18.7 3.6-28.4C6.1 2.8 14.5-1.7 22.4.7c7.9 2.4 12.4 10.7 10 18.6-14.3 48.7 17.3 85.2 100.9 70 34.6-6.5 88.2-5.8 114 20.1 14.7 14.5 23.1 38.5 25 71.3z" />
  </svg>
)
export default Gamesvg
